import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ColoredBar from '../../components/ColoredBar/ColoredBar';
import Nav from '../../components/Nav/Nav';
import rightArrow from '../../assets/designSystem/icons/simple-arrow/right.svg';
import './menu.css';
import MetricsContext from '../../context/MetricsContext';
import PageNames from '../../utils/PageNames';
import PageTypes from '../../utils/PageTypes';

function Menu() {
  const { t, i18n } = useTranslation();
  const { updateUserMetric } = useContext(MetricsContext);
  const startDate = new Date();
  const [showLanguageModal, setShowLanguageModal] = useState(false);

  const sessionId = localStorage.getItem('sessionId');
  useEffect(() => {
    updateUserMetric({
      name: PageNames.MENU_PAGE,
      pageType: PageTypes.DEFAULT,
    });
  }, [sessionId]);

  const updateMetrics = (btn) => {
    const dateFinal = new Date();
    updateUserMetric({
      name: PageNames.MENU_PAGE,
      pageType: PageTypes.DEFAULT,
      duration: Math.abs(dateFinal - startDate),
      interactions: [
        {
          name: btn,
          time: dateFinal,
        },
      ],
    });
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    setShowLanguageModal(false);
  };

  return (
    <div className="container">
      <Nav goBack label={t('menu.title')} />
      <ColoredBar />
      <div className="containerContent menu__container">
        <ul className="menu__ul">
          <li>
            <Link to="/spin-wheel" className="menu__itemContainer" onClick={() => updateMetrics('Spin the Wheel')}>
              <p className="bold">{t('menu.spinWheel')}</p>
              <img src={rightArrow} alt="" />
            </Link>
          </li>
          <li>
            <Link to="/terms" className="menu__itemContainer" onClick={() => updateMetrics('Terms & Conditions')}>
              <p className="bold">{t('menu.tc')}</p>
              <img src={rightArrow} alt="" />
            </Link>
          </li>
          <li>
            <Link to="/policy" className="menu__itemContainer" onClick={() => updateMetrics('Privacy Policy')}>
              <p className="bold">{t('menu.privacy')}</p>
              <img src={rightArrow} alt="" />
            </Link>
          </li>
          <li>
            <a
              href="https://www.kitohealth.org"
              target="_blank"
              rel="noreferrer"
              className="menu__itemContainer"
              onClick={() => updateMetrics('Website')}
            >
              <p className="bold">{t('menu.website')}</p>
              <img src={rightArrow} alt="" />
            </a>
          </li>
          <li>
            <button type="button" className="menu__button" onClick={() => setShowLanguageModal(true)}>
              <p className="bold">{t('menu.language')}</p>
              <img src={rightArrow} alt="" />
            </button>
          </li>
          <li>
            <Link to="/permissions" className="menu__itemContainer" onClick={() => updateMetrics('Manage Permissions')}>
              <p className="bold">{t('menu.permissions')}</p>
              <img src={rightArrow} alt="" />
            </Link>
          </li>
        </ul>
      </div>

      {showLanguageModal && (
        <div className="menu__modalOverlay">
          <div className="menu__modalContent">
            <h3>{t('languagepage.selectlang')}</h3>
            <button type="button" onClick={() => changeLanguage('English')}>
              English
            </button>
            <button type="button" onClick={() => changeLanguage('Swahili')}>
              Swahili
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Menu;
